import React from "react";
import {FaChevronDown} from 'react-icons/fa';

function DataIngestionContent() {
  return (
    <div className="container dataingestionContentMainSection">
      <div className="row dataingestionContentMainSection">
        <div className="col-3 ">
          <div className="row dataingestioncontentsectionRowStyle">
            <div className="col-12">
              <div className="row dataingestioncontentsectionunderline">
                <div className="col-8">Gang Quantity</div>
                <div className="col-2">1.5</div>
                <div className="col-2"><FaChevronDown /></div>
              </div>
            </div>
            <div className="col-12">Resources</div>
            <div className="col-12">Electrician -1</div>
            <div className="col-12">Worker -2</div>
            <div className="col-12"> Helper -3</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DataIngestionContent;
